// src/mixins/mainPageMixin.js
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('report_list', ['selected_report'])
  },
  methods: {
    navigateLink(link) {
      const viewerPrefix = `https://report.qesg.co.kr/v`;
      if (link && !link.startsWith(viewerPrefix)) {
        window.open(link, '_blank');
      } else {
        window.open(this.handlePrefixMatch(link), '_blank');
      }
    },

    handlePrefixMatch(link) {
      if (this.selected_report && this.selected_report.state >= 4) {
        return link;
      } else {
        const { lv1, lv2, lv3 } = this.extractLvFromLink(link);
        if (lv1 && lv2) {
          const routeOptions = {
            name: 'FullView',
            query: {
              lv1: lv1,
              lv2: lv2
            }
          };

          if (lv3) {
            routeOptions.hash = lv3;
          }

          const fullViewPath = this.$router.resolve(routeOptions).href;
          return fullViewPath;
        } else {
          return null;
        }
      }
    },
    extractLvFromLink(link) {
      try {
        const url = new URL(link, window.location.origin); // 상대 경로인 경우를 대비하여 베이스 URL을 지정
        const lv1 = url.searchParams.get('lv1');
        const lv2 = url.searchParams.get('lv2');
        const lv3 = url.hash ? url.hash : null;
        return { lv1, lv2, lv3 };
      } catch (error) {
        this.$Sentry.captureException(error);
        return { lv1: null, lv2: null, lv3: null };
      }
    }
  }
};
